/**
 * DateTime utility functions
 */

/**
 * Format datetime to yyyy/mm/dd HH24:mm:ss format in local timezone
 * @param {string|Date} datetime - The datetime to format
 * @returns {string} Formatted datetime string
 */
export function formatDateTime(datetime) {
  if (!datetime) return '';
  
  const date = new Date(datetime);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * Format date to yyyy/mm/dd format in local timezone
 * @param {string|Date} datetime - The datetime to format
 * @returns {string} Formatted date string
 */
export function formatDate(datetime) {
  if (!datetime) return '';
  
  const date = new Date(datetime);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}/${month}/${day}`;
}

/**
 * Format time to HH24:mm:ss format in local timezone
 * @param {string|Date} datetime - The datetime to format
 * @returns {string} Formatted time string
 */
export function formatTime(datetime) {
  if (!datetime) return '';
  
  const date = new Date(datetime);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) return '';
  
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${hours}:${minutes}:${seconds}`;
}